import { render, staticRenderFns } from "./footer_h5.vue?vue&type=template&id=90f68996&scoped=true"
import script from "./footer_h5.vue?vue&type=script&lang=js"
export * from "./footer_h5.vue?vue&type=script&lang=js"
import style0 from "./footer_h5.vue?vue&type=style&index=0&id=90f68996&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90f68996",
  null
  
)

export default component.exports